import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Stock_Moving_Details = ({ dist_code, office_code, month, year, stock_status }) => {
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);
     const [detail, setDetails] = useState(null);

useEffect(() => {
        setDetails(null);
    }, [month, year, stock_status]);

    
    useEffect(() => {
                setLoading(true);
                axios.get(`${process.env.REACT_APP_URL}/api/stock/stockdetails`, {
            params: { dist_code, office_code, month, year, stock_status }
        }).then(res => {
            setData(res.data);
            setLoading(false);
        });

    }, [dist_code, office_code, month, year, stock_status]);

    if (loading) return <div><img src="src/images/progress.gif" alt="loading"/></div>;

    const { details = [], commodities = [], dist_name = '', office_name = '' } = data;

    if (details.length === 0) {
        return <div align="center">No Transaction Details Found</div>;
    }

    return (
        <div style={{marginTop: '20px'}}>
            <table width="80%" style={{margin: '0 auto', borderCollapse: 'collapse'}} border="1">
                <tbody>
                <tr  className="tableheader" style={{background: '#ddd'}}>
                    <td colSpan={7 + commodities.length}>
                        {dist_name} / {office_name} Stock Update Details for {new Date(0, month-1).toLocaleString('default', { month: 'long' })}'{year}
                    </td>
                </tr>
                <tr  className="tableheader">
                    <td rowSpan="2">Sl.No</td>
                    <td rowSpan="2">From FPS</td>
                    <td rowSpan="2">To FPS</td>
                    <td rowSpan="2">Status</td>
                    <td rowSpan="2">Scheme</td>
                    <td rowSpan="2">Trans Date</td>
                    <td colSpan={commodities.length}>Commodity</td>
                </tr>
                <tr  className="tableheader" style={{background: '#f0f0f0'}}>
                    {commodities.map(c => (
                        <td key={c.distCode}>{c.distNameEn}<br/>({c.afsoNameEn})</td>
                    ))}
                </tr>
                {details.map((row, i) => (
                    <tr key={i}>
                        <td>{i+1}</td>
                        <td>{row.fromFpsId}</td>
                        <td>{row.toFpsId}</td>
                        <td>{row.stockStatus}</td>
                        <td>{row.schemeShortName}</td>
                        <td>{row.transTime}</td>
                        {commodities.map(c => (
                            <td key={c.distCode} align="right">
                                {(row.commodities[c.distCode] || 0).toFixed(3)}
                            </td>
                        ))}
                    </tr>
                ))}
                </tbody>
            </table>
                    <br/>
                    <br/>
                        <br/>    <br/>
                    <br/>
            {detail && <Stock_Moving_Details key={JSON.stringify(detail)} {...detail} />}

        </div>
    );
};

export default Stock_Moving_Details;